import { useRef } from 'react';
import { isFlagStatusEnabled } from '@gonfalon/dogfood-flags/dogfood-flags';
import { getFeatureFlagStatusesQuery } from '@gonfalon/rest-api/queries/flags';
import { useQuery } from '@tanstack/react-query';

interface UseHasFlagEvaluatedProps {
  projectKey: string;
  flagKey: string;
  environmentKey: string;
  enabled?: boolean;
}

export const useHasFlagEvaluated = ({
  projectKey,
  flagKey,
  environmentKey,
  enabled = true,
}: UseHasFlagEvaluatedProps) => {
  const hasEverEvaluatedRef = useRef(false);
  const { data: flagStatus } = useQuery({
    ...getFeatureFlagStatusesQuery({
      projectKey,
      flagKey,
      environmentKeys: [environmentKey],
    }),
    select: (res) => res[environmentKey],
    enabled: isFlagStatusEnabled() && enabled,
    staleTime: hasEverEvaluatedRef.current ? Infinity : 1000 * 60 * 5, // We only need to query the flag status once if it's already evaluating
  });
  const flagHasEvaluated = typeof flagStatus?.lastRequested === 'string';

  // Once the flag starts evaluating, keep staleTime as Infinity
  if (flagHasEvaluated && !hasEverEvaluatedRef.current) {
    hasEverEvaluatedRef.current = true;
  }

  return flagHasEvaluated;
};
